import {
  DELIVERY_NAVIGATION,
  EMERGENCY_NAVIGATION,
  GUEST_NAVIGATION,
  LEASING_OFFICE_NAVIGATION,
  MAINTENANCE_NAVIGATION,
  MISSCELANEAUS_NAVIGATION,
  PROSPECT_NAVIGATION,
  RESIDENT_NAVIGATION,
  SHIFT_CHANGE_NAVIGATION,
  VENDOR_NAVIGATION,
} from './navigation';

export enum VISITOR_TYPES {
  GUEST = 'Guest',
  PROSPECT = 'Prospect',
  VENDOR = 'Vendor',
  DELIVERY = 'Delivery',
  EMERGENCY = 'Emergency (911)',
  // The visitor-log kind. Distinct from RESIDENT below, which is the DAILY-LOG
  // activity ('a note about a resident') — two different tables, two different
  // vocabularies, and Lobbero IQ takes the union of both.
  RESIDENT_ENTRY = 'Resident Entry',
  // Lobbero Stays plan S3: signed in from Expected today, never the wizard.
  SHORT_STAY_GUEST = 'Short-Stay Guest',
  MAINTENANCE = 'Maintenance',
  LEASING_OFFICE = 'Leasing Office',
  RESIDENT = 'Resident',
  MISSCELANEAUS = 'Miscellaneous',
  SHIFT_CHANGE = 'Shift Change',
}
// old
// MISCALLANEOUS
// 'Misscelaneaus',
// new
// MISSCELANEAUS = 'Misscelaneaus',

export const getNavigationFromVisitorType = (visitorType: string | null) => {
  switch (visitorType) {
    case '':
      return [];
    case undefined:
      return [];
    // NO STEPS. 'Resident Entry' is not a wizard — the desk already knows the
    // person, so /visitor-log/resident is one screen and leaves through its own
    // Submit. Listed explicitly so that if the type is ever written into state
    // it lands on an empty navigation (a picker-like shell) rather than on the
    // default branch, which renders a developer message into the header.
    case VISITOR_TYPES.RESIDENT_ENTRY:
      return [];
    // Lobbero Stays plan S3: no steps either — a short-stay guest is signed in
    // with one tap on Expected today, never through this wizard.
    case VISITOR_TYPES.SHORT_STAY_GUEST:
      return [];

    case VISITOR_TYPES.GUEST:
      return GUEST_NAVIGATION;

    case VISITOR_TYPES.PROSPECT:
      return PROSPECT_NAVIGATION;

    case VISITOR_TYPES.VENDOR:
      return VENDOR_NAVIGATION;

    case VISITOR_TYPES.DELIVERY:
      return DELIVERY_NAVIGATION;

    case VISITOR_TYPES.EMERGENCY:
      return EMERGENCY_NAVIGATION;

    case VISITOR_TYPES.MAINTENANCE:
      return MAINTENANCE_NAVIGATION;

    case VISITOR_TYPES.LEASING_OFFICE:
      return LEASING_OFFICE_NAVIGATION;

    case VISITOR_TYPES.RESIDENT:
      return RESIDENT_NAVIGATION;

    case VISITOR_TYPES.MISSCELANEAUS:
      return MISSCELANEAUS_NAVIGATION;

    case VISITOR_TYPES.SHIFT_CHANGE:
      return SHIFT_CHANGE_NAVIGATION;

    default:
      return [
        'Check getNavigationFromVisitorType the parameter is not defined in the case',
      ];
  }
};

export const getTitlesFromRoute = (route: string): string | null => {
  switch (true) {
    case route.includes('/main-menu'):
      return null;
    case route.includes('/visitor-details'):
      return 'Visitor Details';
    case route.includes('/number-of-guests'):
      return 'Number of Guests';
    case route.includes('/apartment-location'):
      return 'Visitor Location';
    case route.includes('/approval'):
      return 'Approval';
    case route.includes('/parking-validation'):
      return 'Parking Validation';
    case route.includes('/notes'):
      return 'Notes';
    case route.includes('/id'):
      return 'ID (Name and Surname)';
    case route.includes('/priority'):
      return 'Priority';
    case route.includes('/description'):
      return 'Description';
    case route.includes('/additional-notes'):
      return 'Additional Notes';
    default:
      return 'Check getTitlesFromRoute the paramater is not defined in the case';
  }
};
